<template>
    <div>
        <ac-auto-reset-modal :banking-info-url="bankingInfoUrl"
                             :fee-form-instance="feeFormInstance"
                             :payee-instance="payeeInstance"
                             :save-fee="saveFee"
                             :path="'components/shared/fees/NewFeeModal.vue'"
                             ref="newFeeModal">

        </ac-auto-reset-modal>
    </div>
</template>

<script>
    import {FeeFormClass} from "../../../../components/shared/fees/FeeFormClass.js";
    import {api} from "../../../../global/framework/api.js";
    import {configTables} from "../../../../global/configTables.js";
    import {PayeeFormClass} from "../../../../components/shared/fees/PayeeFormClass.js";
    import {common} from "../../../../global/common.js";

    let feeFormInstance = new class FeeForm extends FeeFormClass {
        async getAllowedTypes() {
            return configTables.getOpenMarketFeeTypes();
        }

        async getTemplate() {
            return api.getNoId('ProviderFees', 'GetOpenMarketProviderFeeTemplate');
        }
    };
    let payeeFormInstance = null;
    const PayeeFactory = {
        getInstance(providerEntityId) {
            if (payeeFormInstance == null) {
                payeeFormInstance = new class PayeeData extends PayeeFormClass {
                    async getAvailablePayees() {
                        return api.getData('ProviderFees', providerEntityId, 'GetOpenMarketPayees');
                    }
                };
            }
            return payeeFormInstance;
        }
    };
    export default {
        name: "FeeWizardModal",
        props: {providerEntityId: {type: [Number], required: true}},
        data() {
            return {
                feeFormInstance: feeFormInstance,
                payeeInstance: PayeeFactory.getInstance(this.providerEntityId),
                bankingInfoUrl: this.$router.resolve({name: 'bankingInfo', params: {providerEntityId: this.providerEntityId}}).href,
            };
        },
        methods: {
            async showModal() {
                this.$refs.newFeeModal.showModal();
            },
            async saveFee(fee) {
                if (fee.providerPayee !== null && fee.providerPayee.payeeOptionType == common.PAYEE_OPTIONS.SELF) {
                    fee.providerPayee.providerEntityId = this.providerEntityId;//New Fee modal is reusable and does not know anything about specific ids
                }
                return api.postDataAsJson('ProviderFees', 'SaveNewOpenMarketProviderFee', {fee, providerEntityId: this.providerEntityId});
            }
        }
    }
</script>

<style scoped>
</style>